var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"links"}},[_c('PageTitle',{attrs:{"text":"リンク集"}}),_c('SectionTitle',{attrs:{"icon":"mdi-heart","text":"関連サイト"}}),_c('LinkList',{attrs:{"teams":_vm.relatedLinks}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }